<template>
  <el-cascader
    ref="elCascader"
    :options="options"
    :show-all-levels="false"
    :props="defaultProps"
    v-model="dataValue"
    :disabled="disabled"
    style="width: 100%;"
    change-on-select
    @change="valueChange"/>
</template>
<script type="text/javascript">
import arrayMixin from './arrayMixin'
import { productCategoryIndex } from '@/api/systemManagement/SystemCustomer'

export default {
  name: 'XhProducCate', // 新建 產品分類
  components: {},
  mixins: [arrayMixin],
  props: {},
  data() {
    return {
      options: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'category_id'
      }
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getProductCategoryIndex()
  },
  methods: {
    /** 獲取產品分類數據 */
    getProductCategoryIndex() {
      productCategoryIndex({
        type: 'tree'
      })
        .then(res => {
          this.options = res.data
        })
        .catch(() => {})
    },

    valueChange(val) {
      this.$emit('input', val)
      const cascader = this.$refs.elCascader
      const labels = cascader && cascader.currentLabels ? cascader.currentLabels : []
      this.$emit('value-change', {
        index: this.index,
        item: this.item,
        value: val,
        valueContent: labels.join(',')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
